/**
 * colors
 *
 * makes the colors, corresponding with _colors.scss, available in javascript
 */
import globalColors from '@data/variables/global-colors';

function colors () {
	/* Calculate color between color1 and color2. Source: http://www.programming-idioms.org/idiom/154/halfway-between-two-hex-color-codes */
	function getColorBetween (c1, c2) {
		let c = '#';
		for (let i = 0; i < 3; i++) {
			const sub1 = c1.substring(1 + 2 * i, 3 + 2 * i);
			const sub2 = c2.substring(1 + 2 * i, 3 + 2 * i);
			const v1 = parseInt(sub1, 16);
			const v2 = parseInt(sub2, 16);
			const v = Math.floor((v1 + v2) / 2);
			const sub = v.toString(16).toUpperCase();
			const padsub = `0${sub}`.slice(-2);
			c += padsub;
		}
		return c;
	}

	/* Calculate colors to depict positive and negative values */
	function getPositiveToNegativeColors (amount) {
		switch (amount) {
			case 1:
				const c11 = globalColors.brand4.light;
				return [c11];
			case 2:
				const c21 = globalColors.brand4.light;
				const c22 = globalColors.brand3.dark;
				return [c21, c22];
			case 3:
				const c31 = globalColors.brand4.light;
				const c32 = globalColors.brand1.dark;
				const c33 = globalColors.brand3.dark;
				return [c31, c32, c33];
			case 4:
				const c41 = globalColors.brand4.light;
				const c43 = globalColors.brand1.dark;
				const c44 = globalColors.brand3.dark;
				const c42 = getColorBetween(c41, c43);
				return [c41, c42, c43, c44];
			case 5:
				const c51 = globalColors.brand4.light;
				const c53 = globalColors.brand1.dark;
				const c55 = globalColors.brand3.dark;
				const c52 = getColorBetween(c51, c53);
				const c54 = getColorBetween(c53, c55);
				return [c51, c52, c53, c54, c55];
			case 6:
				const c61 = globalColors.brand4.light;
				const c63 = globalColors.brand1.dark;
				const c66 = globalColors.brand3.dark;
				const c62 = getColorBetween(c61, c63);
				const c64 = getColorBetween(c63, c66);
				const c65 = getColorBetween(c64, c66);
				return [c61, c62, c63, c64, c65, c66];
			case 7:
				const c71 = globalColors.brand4.light;
				const c74 = globalColors.brand1.dark;
				const c77 = globalColors.brand3.dark;
				const c72 = getColorBetween(c71, c74);
				const c73 = getColorBetween(c72, c74);
				const c75 = getColorBetween(c74, c77);
				const c76 = getColorBetween(c75, c77);
				return [c71, c72, c73, c74, c75, c76, c77];
			case 8:
				const c81 = globalColors.brand4.light;
				const c84 = globalColors.brand1.dark;
				const c88 = globalColors.brand3.dark;
				const c82 = getColorBetween(c81, c84);
				const c83 = getColorBetween(c82, c84);
				const c85 = getColorBetween(c84, c88);
				const c86 = getColorBetween(c85, c88);
				const c87 = getColorBetween(c86, c88);
				return [c81, c82, c83, c84, c85, c86, c87, c88];
			case 9:
				const c91 = globalColors.brand4.light;
				const c99 = globalColors.brand3.dark;
				const c95 = globalColors.brand1.dark;
				const c92 = getColorBetween(c91, c95);
				const c93 = getColorBetween(c92, c95);
				const c94 = getColorBetween(c93, c95);
				const c96 = getColorBetween(c95, c99);
				const c97 = getColorBetween(c96, c99);
				const c98 = getColorBetween(c97, c99);
				return [c91, c92, c93, c94, c95, c96, c97, c98, c99];
			default:
				const c1 = globalColors.brand4.light;
				const c10 = globalColors.brand3.dark;
				const c5 = globalColors.brand1.dark;
				const c2 = getColorBetween(c1, c5);
				const c3 = getColorBetween(c2, c5);
				const c4 = getColorBetween(c3, c5);
				const c6 = getColorBetween(c5, c10);
				const c7 = getColorBetween(c6, c10);
				const c8 = getColorBetween(c7, c10);
				const c9 = getColorBetween(c8, c10);
				return [c1, c2, c3, c4, c5, c6, c7, c8, c9, c10];
		}
	}
	window.getPositiveToNegativeColors = getPositiveToNegativeColors;

	/* Calculate the colors for charts based on the amount of colors needed, to fake a 'gradient' effect, based on the three main colors that decide the 'gradient' */
	function getChartColors (amount) {
		let c1 = globalColors.brand2.dark;
		let c2 = globalColors.brand3.dark;
		let c3 = globalColors.brand1.dark;
		if (window.chartColorOverrides && window.chartColorOverrides.length == 3) {
			c1 = window.chartColorOverrides[0];
			c2 = window.chartColorOverrides[1];
			c3 = window.chartColorOverrides[2];
		}

		var middle = parseInt(Math.floor(amount / 2));
		var colors = [];
		colors[0] = c1;
		colors[middle] = c2;
		colors[amount - 1] = c3;

		if (amount > 7) {
			var firstmiddle = parseInt(Math.floor(middle / 2));
			colors[firstmiddle] = getColorBetween(colors[0], colors[middle])
			var secondmiddle = parseInt(middle + firstmiddle);
			colors[secondmiddle] = getColorBetween(colors[middle], colors[amount - 1]);
			console.log('nrs', firstmiddle, middle, secondmiddle, amount - 1);
			for (var i = 1; i < firstmiddle; i++) {
				colors[i] = getColorBetween(colors[i - 1], colors[firstmiddle]);
			}
			for (var i = firstmiddle + 1; i < middle; i++) {
				colors[i] = getColorBetween(colors[i - 1], colors[middle]);
			}
			for (var i = middle + 1; i < secondmiddle; i++) {
				colors[i] = getColorBetween(colors[i - 1], colors[secondmiddle]);
			}
			for (var i = secondmiddle + 1; i < amount - 1; i++) {
				colors[i] = getColorBetween(colors[i - 1], colors[amount - 1]);
			}
		}
		else {
			for (var i = 1; i < middle; i++) {
				colors[i] = getColorBetween(colors[i - 1], colors[middle]);
			}
			for (var i = middle + 1; i < amount - 1; i++) {
				colors[i] = getColorBetween(colors[i - 1], colors[amount - 1]);
			}
		}
		return colors;


	}
	window.getChartColors = getChartColors;
	window.globalColors = globalColors;
	/* Helper class for fabricator material 'chartcolors' */

	function doChartColors () {
		$('.js-chart-colors').each(function (i) {
			const $this = $(this);
			const amount = $this.data('colors-count');
			const colors = getChartColors(amount);
			$this.html(' ');
			for (let i = 0; i < amount; i++) {
				$this.append(`<div class='tile' style='background-color: ${colors[i]}'>Colors of a chart with ${amount} colors</div>`);
			}
		});
	}

	window.doChartColors = doChartColors;

	function doMeasureColors () {
		$('.js-measure-colors').each(function (i) {
			const $this = $(this);
			const amount = $this.data('colors-count');
			const colors = getPositiveToNegativeColors(amount);
			$this.html(' ');
			for (let i = 0; i < amount; i++) {
				$this.append(`<div class='tile' style='background-color: ${colors[i]}'>Colors of a chart with ${amount} colors</div>`);
			}
		});
	}

	window.doMeasureColors = doMeasureColors;
}
colors();
